import simbApi from ".";
import { GET_BOARD_SETTINGS, GET_CONNECTED_BOARDS, UPDATE_BOARD_SETTINGS } from "../../data/constants/endpoints";

export const getBoardSettings = async (access_token: string, boardId: number) => {
  try {
    const response = await simbApi.get(GET_BOARD_SETTINGS, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: {
        boardId,
      },
    });

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getConnectedBoards = async (access_token: string, boardId: number) => {
  try {
    const response = await simbApi.get(GET_CONNECTED_BOARDS, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: {
        boardId,
      },
    });

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateBoardSettings = async (access_token: string, boardId: number, type: string, settingKey: string, value: any, excludedBoards?: string[]) => {
  try {
    const response = await simbApi.post(
      UPDATE_BOARD_SETTINGS,
      {
        boardId,
        type,
        settingKey,
        value,
        excludedBoards,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};
